import { FC, ReactNode } from 'react'
import DOMPurify from 'isomorphic-dompurify'
import clsx from 'clsx'

import styles from './property.module.scss'

interface IProperty {
  text: string
  label?: string
  wrapperModificator?: string
  labelModificator?: string
  modificator?: string
  icon?: ReactNode
  children?: ReactNode
}

const Property: FC<IProperty> = ({
  text,
  label,
  wrapperModificator,
  labelModificator,
  modificator,
  icon,
  children,
}: IProperty) => (
  <div
    className={clsx(styles.propertyWrapper, {
      [wrapperModificator as string]: wrapperModificator,
    })}
  >
    {label && (
      <div
        className={clsx(styles.label, {
          [labelModificator as string]: labelModificator,
        })}
      >
        {label}
      </div>
    )}
    <div className={styles.propertyBlock}>
      <div
        className={clsx(styles.property, {
          [modificator as string]: modificator,
        })}
      >
        {icon}
        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
      </div>
      {children}
    </div>
  </div>
)

export default Property
